var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home data-panel-home"},[_c('Layout',{attrs:{"type":"HOME","pageTitle":_vm.$t('pageTitle'),"titleSrc":"/menu/homeIcon_black.png"}},[_c('Tips',{staticClass:"buyback-tips",attrs:{"title":_vm.$t('提现注意事项'),"tips":_vm.tips}}),_c('CommitBuyBack',{attrs:{"type":"94"}}),_c('BuyBackList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }